import React, { useState, useEffect } from 'react';
import '../styles/sidebar.css';

/* Simple icon map using emoji — keeps bundle small, no extra dep needed for dashboard icons */
const iconMap = {
  users: '👥',
  addresses: '📍',
  alerts: '🔔',
  articles: '📰',
  authors: '✍️',
  companies: '🏢',
  company_addresses: '🏣',
  configurations: '⚙️',
  keywords: '🔑',
  permissions: '🔐',
  role_permissions: '🛡️',
  roles: '👔',
  sources: '📡',
  user_addresses: '🏠',
  user_alert: '📢',
  user_roles: '🎭',
};

const Sidebar = ({ endpoints, activeEndpoint, onSelect }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (!mobile) setIsMobileOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSelect = (id) => {
    onSelect(id);
    if (isMobile) setIsMobileOpen(false);
  };

  return (
    <>
      {/* Mobile toggle */}
      {isMobile && (
        <button
          className="sidebar-mobile-toggle"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="Toggle sidebar"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          <span>Menu</span>
        </button>
      )}

      {/* Overlay */}
      {isMobile && isMobileOpen && (
        <div className="sidebar-overlay" onClick={() => setIsMobileOpen(false)} />
      )}

      <aside className={`sidebar ${isCollapsed ? 'sidebar--collapsed' : ''} ${isMobileOpen ? 'sidebar--mobile-open' : ''}`}>
        <div className="sidebar__header">
          {!isCollapsed && <h3 className="sidebar__title">Navigation</h3>}
          {!isMobile && (
            <button className="sidebar__collapse-btn" onClick={() => setIsCollapsed(!isCollapsed)} aria-label="Toggle sidebar">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ transform: isCollapsed ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>
                <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          )}
        </div>

        <ul className="sidebar__menu">
          {endpoints.map((endpoint, i) => (
            <li key={endpoint.id}>
              <button
                className={`sidebar__item ${activeEndpoint === endpoint.id ? 'sidebar__item--active' : ''}`}
                onClick={() => handleSelect(endpoint.id)}
                title={isCollapsed ? endpoint.name : undefined}
                style={{ animationDelay: `${i * 30}ms` }}
              >
                <span className="sidebar__icon">{iconMap[endpoint.id] || '📋'}</span>
                {!isCollapsed && <span className="sidebar__label">{endpoint.name}</span>}
                {activeEndpoint === endpoint.id && <span className="sidebar__active-indicator" />}
              </button>
            </li>
          ))}
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;
